import React from "react";

const Resources = (props) => {
    return <div className={"rob-resources"}>
        <div className="rob-resources__title"><h4>Useful Links and Information</h4>
        </div>
        <div className="rob-resources__content">
            {props.resources.map(function (name, index) {
                    return <div key={index}>
                        <a className="rob-resource__link" href={name.url} >
                            <div className="rob-resource__content">
                                <h3>{name.text}</h3>
                                <p>{name.subheading}</p>
                            </div>
                        </a>
                    </div>
            })
            }
        </div>
    </div>


};

Resources.defaultProps = {resources: []};
export default Resources



// WEBPACK FOOTER //
// ./src/components/elements/Resources.js